export default __webpack_public_path__ + "static/media/img-text-blue.47113ca1.svg";